angular.module('moebiusProadapt').controller('ctrlParcoursDeSoin',
    ['$rootScope','$scope', '$http', '$location', '$uibModal', function($rootScope, $scope, $http, $location, $uibModal){

/////////// COMMON TOOL ///////////

        // Open a modal with a textarea fill with the content of the courrier. Click on it will select it.
        $scope.openModalCourrierToSend = function (mail_text) {
            $uibModal.open({
                template:"<textarea style='width:100%; min-height:200px; padding:10px;' onclick='this.select()'>" + mail_text + "</textarea>" +
                    "<div style='text-align: right; padding:8px'><button class='btn btn-secondary' type='button' ng-click='$close()'>Fermer</button></div>",
                controller: 'ctrlParcoursDeSoin',
                windowClass: 'md-dialog',
                scope: $scope.$new(),
                backdrop: true,
                keyboard: false
            });
        };

/////////// SYNDROME APNEE DU SOMMEIL - STOP BANG ///////////

        $scope.getQmVal = function(qm, nullValue = null){
            var qmVal = $rootScope.participant.getValue($rootScope.visite.getQuestionVisiteForQuestionMereKeyShort(qm));
            return qmVal !== null ? qmVal : nullValue;
        };

        $scope.color_pastilles = {
            noAnswer: "#62abb7",
            red:      "#ba4646",
            orange:   "#f0813c",
            green:    "#7eb00f"
        };

        $scope.getCourrierDepistage = function(){
            const courrierDepistage = $scope.getQmVal('QM__FORMULE_COURRIER_DEPISTAGE');
            return courrierDepistage ? $rootScope.constants.courriers_et_prescriptions.VALUES_TO_DISPLAY[courrierDepistage] : null;
        };

        $scope.getColorStopBang = function(){
            const scoreStopBang = $scope.getQmVal('QM__SCORE_STOP_BANG');

            // - score STOP BANG :
            //      -  < 3 : pastille verte
            //      -  = 3 - 4 : pastille orange
            //      -  > 4 : pastille rouge
            return scoreStopBang === null ?  $scope.color_pastilles.noAnswer  :
                   scoreStopBang < 3      ?  $scope.color_pastilles.green     :
                   scoreStopBang < 5      ?  $scope.color_pastilles.orange    :
                                             $scope.color_pastilles.red;
        };

        $scope.getColorScoreSas = function(){
            const scoreSas = $scope.getQmVal('QM__FORMULA_MANQUE_DE_SOMMEIL_NBRE_DE_OUI');

            // - Score manque de sommeil :
            //      - Nombre de oui = 0 : pastille verte
            //      - Nombre de oui = 1 : pastille orange
            //      - Nombre de oui = 2 : pastille rouge
            return scoreSas === null ? $scope.color_pastilles.noAnswer :
                   scoreSas === 0    ? $scope.color_pastilles.green    :
                   scoreSas === 1    ? $scope.color_pastilles.orange   :
                                       $scope.color_pastilles.red;
        };

        $scope.getColorHeaderSas = function(){
            const scoreSas = $scope.getQmVal('QM__FORMULA_MANQUE_DE_SOMMEIL_NBRE_DE_OUI');
            const scoreStopBang = $scope.getQmVal('QM__SCORE_STOP_BANG');

            // - Couleur de l’onglet SAS : reprend la plus grande valeur trouvée parmi les pastilles (STOP BANG et Signes de manque de sommeil)
            //      - si tout vert : onglet vert
            //      - si au moins 1 rouge : onglet rouge
            //      - si aucune rouge et au moins 1 orange : onglet orange
            return scoreSas === null  || scoreStopBang === null ? $scope.color_pastilles.noAnswer :
                   scoreSas === 0     && scoreStopBang < 3      ? $scope.color_pastilles.green    :
                   scoreStopBang >= 5 || scoreSas === 2         ? $scope.color_pastilles.red      :
                                                                  $scope.color_pastilles.orange;
        };



/////////// PBM GESTION SANGUINE ///////////

        $scope.getScoreHemostase = function(){
            const scoreHemostase = $scope.getQmVal('QM__FORMULE_HEMOSTASE_NOMBRE_DE_OUI');
            return scoreHemostase;
        };

        $scope.getTauxHemoglobine = function(){
            const tauxHemoglobine = $scope.getQmVal('QM__TAUX_HEMOGLOBINE');
            return tauxHemoglobine;
        };

        $scope.getCourrierHemostase = function(){
            const courrierHemostase = $scope.getQmVal('QM__FORMULE_COURRIER_HEMOSTASE');

            if(courrierHemostase){
                return $rootScope.constants.courriers_et_prescriptions.VALUES_TO_DISPLAY[courrierHemostase];
            }else{
                return null;
            }
        };

        $scope.getCourrierPrescriptionBilanBiologique = function(){
            const courrierPrescriptionBilanBiologique = $scope.getQmVal('QM__FORMULE_COURRIER_PRESCRIPTION_BILAN_BIOLOGIQUE');

            if(courrierPrescriptionBilanBiologique){
                return $rootScope.constants.courriers_et_prescriptions.VALUES_TO_DISPLAY[courrierPrescriptionBilanBiologique];
            }else{
                return null;
            }
        };

        $scope.getCourrierPrescriptionFer = function(){
            const courrierPrescriptionFer = $scope.getQmVal('QM__FORMULE_COURRIER_PRESCRIPTION_FER');

            if(courrierPrescriptionFer){
                return $rootScope.constants.courriers_et_prescriptions.VALUES_TO_DISPLAY[courrierPrescriptionFer];
            }else{
                return null;
            }
        };

        $scope.getColorOngletPbm = function(){
            const scoreHemostase = $scope.getScoreHemostase();
            const tauxHemoglobine = $scope.getTauxHemoglobine();

            // Couleur onglet PBM : reprend la plus grande valeur trouvée parmi les pastilles (hémoglobine et hémostase)
            // - si tout vert : onglet vert
            // - si au moins 1 rouge : onglet rouge
            // - si aucune rouge et au moins 1 orange : onglet orange
            return scoreHemostase === null || tauxHemoglobine === null ? $scope.color_pastilles.noAnswer :
                   scoreHemostase === 0 && tauxHemoglobine >= 130      ? $scope.color_pastilles.green    :
                   scoreHemostase > 2 || tauxHemoglobine < 100         ? $scope.color_pastilles.red      :
                                                                         $scope.color_pastilles.orange;
        };


        $scope.getColorHemostase = function(){
            const scoreHemostase = $scope.getScoreHemostase();

            return scoreHemostase === null  ? $scope.color_pastilles.noAnswer :
                   scoreHemostase === 0     ? $scope.color_pastilles.green    :
                   scoreHemostase > 2       ? $scope.color_pastilles.red      :
                                              $scope.color_pastilles.orange;
        };


        $scope.openModalScoreHemostase = function () {
            var scopeModal = $scope.$new();

            scopeModal.documentationScore = {
                nomQuestionnaire: "Hemostase",
                cheminRelatifImage: "scores_images/QM__SCORE_HEMOSTASE.png"
            };
            $uibModal.open({
                templateUrl: 'assets/templates/generic_templates/modal/modal-documentation-score.html',
                windowClass: 'lg-dialog',
                scope: scopeModal,
                backdrop: 'static',
            });
        };


        /////////// NUTRITION ///////////

        $scope.getGN = function(){
            return $scope.getQmVal('QM__FORMULE_COURRIER_GN');
        };

        $scope.getGNCourrier = function(){
            const GNCourrier = $scope.getGN();

            if(GNCourrier){
                return $rootScope.constants.courriers_et_prescriptions.VALUES_TO_DISPLAY[GNCourrier];
            }else{
                return null;
            }
        };

        /////////// SEVRAGE TABAC ALCOOL ///////////

        $scope.score_dependance_alcool = $rootScope.participant.getValue($rootScope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__SCORE_ALCOOL'));

        $scope.courrier_substitut_nicotinique = $rootScope.participant.getValue($rootScope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__FORMULE_COURRIER_PRESCRIPTION_SUBSTITUT_NICOTINIQUE'));
        if($scope.courrier_substitut_nicotinique){
            $scope.courrier_substitut_nicotinique = $rootScope.constants.courriers_et_prescriptions.VALUES_TO_DISPLAY[$scope.courrier_substitut_nicotinique];
        }

        $scope.getScoreFagestromColor = function(){
            const is_fumeur = $scope.getQmVal('QM__ETES_VOUS_FUMEUR');
            const score_fagerstrom = $scope.getQmVal('QM__SCORE_FAGERSTROM');

            return is_fumeur === null || is_fumeur === false || score_fagerstrom === null ? null :
                   score_fagerstrom < 2                                                   ? $scope.color_pastilles.green    :
                   score_fagerstrom >= 6                                                  ? $scope.color_pastilles.red      :
                                                                                            $scope.color_pastilles.orange;
        };
        $scope.getScoreAlcoolColor = function(){
            const is_alcoolique = $scope.getQmVal('QM__CONSOMMEZ_VOUS_REGULIEREMENT_DE_LALCOOL');
            const score_dependance_alcool = $scope.getQmVal('QM__SCORE_ALCOOL');

            return is_alcoolique === null || is_alcoolique === false || score_dependance_alcool === null ? null :
                   score_dependance_alcool <= 8                                                          ? $scope.color_pastilles.green    :
                   score_dependance_alcool >= 13                                                         ? $scope.color_pastilles.red      :
                                                                                                           $scope.color_pastilles.orange;
        };


        $scope.getColorHeaderTabac = function(){
            const is_fumeur = $scope.getQmVal('QM__ETES_VOUS_FUMEUR');
            const score_fagerstrom = $scope.getQmVal('QM__SCORE_FAGERSTROM');
            const is_alcoolique = $scope.getQmVal('QM__CONSOMMEZ_VOUS_REGULIEREMENT_DE_LALCOOL');
            const score_dependance_alcool = $scope.getQmVal('QM__SCORE_ALCOOL');

            // - Couleur de l’onglet : reprend la plus grande valeur trouvée parmi les pastilles
            //       - Si pas de tabac et alcool : onglet vert
            //       - Si score de dépendance (alcool >= 13  ou tabac >= 6) = rouge : onglet rouge
            //       - Sinon onglet orange

            return is_fumeur === null || is_alcoolique === null           ? $scope.color_pastilles.noAnswer :
                   !is_fumeur && !is_alcoolique                           ? $scope.color_pastilles.green    :
                   score_fagerstrom >= 6 || score_dependance_alcool >= 13 ? $scope.color_pastilles.red      :
                                                                            $scope.color_pastilles.orange;
        };
    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/participantParcoursSoin.js